/*
 * File: MenuKeys.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:04:24 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */
export enum MenuKeys {
  logout = 'Log Out',
  about = 'About',
  profile = 'Profile',
  releaseNotes = 'Release Notes'
}

export enum SalesOrderFormMenuKeys {
  CustomerSelection = 'customer-selection',
  HeaderInfo = 'header-info',
  DeliveryAddress = 'delivery-address',
  DeliveryDetails = 'delivery-details',
  ProductsSelection = 'products',
  Attachments = 'attachments',
  Overview = 'overview'
}
